
export class Peer {
    usuario: number;
    secret : number;
    personal: number;
    protocolo: string;
    dtmf = 'rfc2833';
    nat = 'auto_comedia';
    call_limit: number = 2;
    fwd: string = '';
    busyfwd: string = '';
    delayedfwd: string = '';
    email: string = '';
    callerid: string = 'Extension';
    voice: boolean = false;
    spy: boolean = false;
    acceptExternal: boolean = true;
    grupos: string | { grupo: string }[] = [{grupo: '1'}]
    // 
    perfil: PeerPerfil[] = [];
    
    constructor(){}
}

export class PeerPerfil {
    usuario: number;
    contexto: string;
    limit: number;
    
    constructor(usuario: number) {
        this.usuario = usuario;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/peer.ts